import { EventBus } from '@/utils/eventBus';

export default {
	bind(el) {
		el.addEventListener('mousemove', (e) => {
			const target = e.target.closest('.xiaowen');
			if (target) {
				EventBus.$emit('tooltip:show', {
					mouseX: e.clientX,
					mouseY: e.clientY,
					element: target
				});
			}
		});

		el.addEventListener('mouseleave', () => {
			EventBus.$emit('tooltip:hide');
		});
	}
};